<template>
<article>
  <section v-for="post in posts" :key="post.slug">
    <h1>{{ post.title }}</h1>
    <div v-html="renderMarkdown(post.data)"></div>
  </section>
</article>
</template>

<script>
import Marked from 'marked'

export default {
  name: 'posts',
  props: [
    'offset',
    'limit',
    'short'
  ],
  data () {
    return {
      posts: []
    }
  },
  methods: {
    renderMarkdown (text) {
      Marked.setOptions({
        renderer: new Marked.Renderer(),
        gfm: true,
        tables: true,
        breaks: true,
        pedantic: false,
        sanitize: true,
        smartLists: true,
        smartypants: false
      })
      return Marked(text)
    }
  },
  created () {
    console.log(`o:${this.offset} l:${this.limit} s:${this.short}`)
  },
  async mounted () {
    try {
      const resp = await fetch(`https://gigavoid.com/api/news?offset=${this.offset}&limit=${this.limit}`)
      this.posts = await resp.json()
    } catch (err) {
      console.log(err)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/posts.vue